import React from 'react'
import NavBar from '../../components/NavBar'
import Footer from '../../components/Footer'
import { Link } from 'react-router-dom'
import Faq from '../../components/Faq';
import Meta from '../../components/Meta';
import openForeignCompany from "../../assets/images/open-Foreign-Company.png"
import BidaImg from "../../assets/images/Bida-.png"
import foreigncompanydirectorserviceImg from "../../assets/images/foreign-company-director-service-1.png"
import foreigncompanyregisteredaddressImg from "../../assets/images/foreign-company-registered-address-1.png"
import foreignDelegatesImg from "../../assets/images/Foreign-Delegates-1.png"
import directorServiceImg from "../../assets/images/Foreign-Direct-Investment-Investment-Bangladesh.png"
import privateInvestmentImg from "../../assets/images/Foreign-Direct-Investment-Investment-Bangladesh.png"
import workPermitVISA from "../../assets/images/Work-Permit.png"
import Marquee from "react-fast-marquee";
import MarqueeCard from '../../components/MarqueeCard'
import directorServiceImg2 from "../../assets/images/Methods-of-FDI-606x1024.png"

function ForeignDirectInvestment() {
    const faqItems = [
        {
            title: ' What is the current foreign direct investment in Bangladesh?',
            content: <strong>FDI in Figures. According to the UNCTAD's World Investment Report 2023, FDI inflows
                to Bangladesh increased by 20.2% to USD 3.48 billion in 2022 (compared to USD 2.89 billion in
                2021). In the same year, the total stock of FDI was estimated at USD 21.1 billion, representing
                only 4.6% of the country's GDP.</strong>
        },
        {
            title: 'Which sector has the highest foreign direct investment in Bangladesh? ',
            content: <strong>Sectoral distribution of FDI inflows
                There are three broad sectors of FDI inflows: infrastructure, manufacturing, and services. The
                shares of the three sectors are 46 percent, 27 percent and 27 percent respectively (Chart 3).</strong>
        },
        {
            title: 'How does FDI affect Bangladesh?',
            content: <strong> According to research, a ten percent increase in FDI can lead to a 3.7 percent
                increase in Bangladesh's GDP. A 13% annual growth in FDI can reduce poverty by 1%.
                Encouraging FDI growth is crucial to making a real impact on alleviating poverty.</strong>
        }
    ];
    return (
        <>
            <Meta title="Foreign Direct Investment"
                description="This page provides information about BSTI permission and related processes."
                image={foreigncompanydirectorserviceImg}
                keywords="keyword1, keyword2, keyword3"
            />
            <NavBar />

            <div className="container-fluid hero-header bg-light py-5 mb-5">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <h1 className="display-4 mb-3 animated slideInDown">Foreign Direct Investment</h1>
                            <nav aria-label="breadcrumb animated slideInDown">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="#">Foreign Entity</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Foreign Direct Investment</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-6 animated fadeIn">
                            <img className="img-fluid animated pulse infinite" style={{ animationDuration: '3s' }} src={directorServiceImg} alt='Foreign-Direct-Investment-Investment-Bangladesh' />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <p>
                        Foreign Direct Investment (FDI) refers to the investment made by a foreign entity,
                        such as a company or an individual, in a business enterprise located in another
                        country. FDI involves a long-term commitment of capital and other resources, with
                        the aim of establishing a lasting interest in the operations of the enterprise.
                    </p>
                    <p className="color-text fs-5 mb-4">
                        <b>What is Foreign Direct Investment and importance</b>
                    </p>
                    <p>
                        Foreign direct investment (FDI) refers to an investment made by a company or individual
                        from one country into a business or entity located in another country. This investment
                        can take many forms, such as buying or establishing a new business, acquiring a company,
                        or investing in an existing enterprise.<br /><br />

                        FDI is often considered a key driver of economic growth and development, as it can
                        bring in new capital, technology, and skills to a host country, which can boost
                        productivity, employment, and income levels. Foreign Direct Investment can also help
                        diversify a country’s economy, provide access to new markets, and promote innovation
                        and knowledge transfer.<br /><br />

                        Governments often encourage FDI through policies and incentives, such as tax breaks,
                        subsidies, and streamlined regulations, as they can bring in significant economic
                        benefits. However, FDI can also raise concerns about issues such as national security,
                        sovereignty, and cultural impact, which can lead to debates about its merits and
                        drawbacks.
                    </p>
                    <p className="color-text fs-5 mb-4">
                        <b>Types of Foreign Direct Investment</b>
                    </p>
                    <p>
                        There are two main types of foreign direct investment (FDI):
                    </p>
                    <p>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Inward FDI: </b>Inward FDI refers to the investment made by a foreign
                                company or individual into a business located in the host country. For
                                example, a German car company investing in a car manufacturing plant in the
                                United States.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Outward FDI: </b>Outward FDI refers to the investment made by a company
                                located in the host country into a foreign business or entity. For example,
                                an American technology company investing in a software development firm in
                                India.
                            </span>
                        </div>
                    </p>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <img className="img-fluid" src={directorServiceImg2} alt='Methods-of-FDI-606x1024' />
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="h-100">
                                <p className="color-text fs-5 mb-4">Methods of FDI</p>
                                <p>
                                    There are several methods of FDI which are given below:
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span>
                                            <b> Greenfield investment: </b>A greenfield investment refers to
                                            establishing a new business or entity in a foreign country from
                                            scratch. This can involve building new facilities, hiring
                                            employees, and starting operations.
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span>
                                            <b>Mergers and acquisitions: </b>Mergers and acquisitions (M&A)
                                            involve purchasing an existing business or entity in a foreign
                                            country. This can involve acquiring the entire business or just
                                            a controlling stake.
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span>
                                            <b>Joint venture: </b>A joint venture is a partnership between a
                                            foreign company and a local company in the host country. The two
                                            companies agree to pool their resources and expertise to create a
                                            new business entity.
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span>
                                            <b>Strategic alliance: </b>A strategic alliance is a partnership
                                            between two or more companies to achieve a specific goal. This
                                            can involve sharing resources, technology, and expertise to
                                            develop a new product or enter a new market.
                                        </span>
                                    </div>
                                </p>
                                <p className="color-text fs-5 mb-4">
                                    What is the current state of foreign direct investment in Bangladesh?
                                </p>
                                <p>
                                    Foreign direct investment (FDI) has been steadily increasing in Bangladesh
                                    over the past decade. According to the World Investment Report 2021 by the
                                    United Nations Conference on Trade and Development (UNCTAD), FDI inflows to
                                    Bangladesh increased by 25% in 2020 to reach USD 2.1 billion, despite the
                                    global pandemic.<br /><br />

                                    The key sectors attracting foreign investment in Bangladesh include:
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span>
                                            <b>Ready-made garments (RMG) industry: </b>Bangladesh is the
                                            world’s second-largest RMG exporter, and the sector accounts for
                                            over 80% of the country’s total exports. The government has
                                            taken various initiatives to boost the sector, including
                                            establishing special economic zones and offering tax incentives
                                            to investors.
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span>
                                            <b>Power and energy: </b>Bangladesh is investing heavily in power
                                            and energy infrastructure to meet the growing demand for
                                            electricity. The government has launched various projects to
                                            increase power generation capacity, including renewable energy
                                            sources such as solar, wind, and hydroelectricity.
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span>
                                            <b>Information technology and communication: </b>The country has
                                            a large pool of talented IT professionals, and the government is
                                            actively promoting the sector through various initiatives,
                                            including offering tax exemptions and establishing IT parks.
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span>
                                            <b>Pharmaceuticals: </b>The pharmaceutical sector in Bangladesh
                                            is growing rapidly, driven by the increasing demand for
                                            affordable drugs in the domestic and international markets.
                                            The government is providing various incentives to encourage
                                            investment in the sector, including tax holidays and duty-free
                                            imports of raw materials.
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span>
                                            <b>Infrastructure: </b>The government has launched various
                                            infrastructure development projects, including roads, bridges,
                                            and ports, to improve connectivity and attract foreign
                                            investment in the country.
                                        </span>
                                    </div>
                                    Overall, Bangladesh offers several investment opportunities in various
                                    sectors, and the government is taking proactive steps to create a
                                    business-friendly environment for foreign investors.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-xxl py-0">
                <div className="container">
                    <p className="color-text fs-5 mb-4">
                        <b>What are the government policies and incentives in place to promote foreign direct investment in Bangladesh?</b>
                    </p>
                    <p>
                        The government of Bangladesh has implemented several policies and incentives to
                        promote foreign direct investment (FDI) in the country. Some of the key policies and
                        incentives are:
                    </p>
                    <p>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Tax breaks: </b>The government offers tax holidays ranging from three to
                                seven years for new industries and for the expansion of existing industries.
                                It also offers reduced tax rates for certain industries, such as software
                                development and IT-enabled services.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Special economic zones (SEZs): </b>The government has established SEZs
                                across the country to attract FDI and provide a business-friendly
                                environment. These zones offer various incentives, including tax exemptions,
                                duty-free import of raw materials, and streamlined administrative
                                procedures.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Investment facilitation services: </b>The government has set up various
                                investment facilitation services to assist foreign investors in setting up
                                their businesses in Bangladesh. These services include a One Stop Service
                                (OSS) to provide streamlined administrative procedures, and the Bangladesh
                                Investment Development Authority (BIDA) to facilitate investment and promote
                                business-friendly policies.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Export subsidies: </b>The government offers various export subsidies to
                                promote exports and attract FDI in export-oriented industries. These
                                subsidies include cash incentives, duty drawback, and bonded warehouse
                                facilities.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Infrastructure development: </b>The government is investing heavily in
                                infrastructure development to improve connectivity and attract FDI. It has
                                launched various projects, including the construction of roads, bridges, and
                                ports, and is also investing in power and energy infrastructure.
                            </span>
                        </div>
                        Overall, the government of Bangladesh has implemented several policies and
                        incentives to promote FDI and create a business-friendly environment for
                        investors.
                    </p>
                    <p className="color-text fs-5 mb-4">
                        <b>What are the investment procedures and regulations for foreign investors in Bangladesh?</b>
                    </p>
                    <p>
                        Foreign investors looking to invest in Bangladesh must follow certain investment
                        procedures and regulations set by the government. Here are some key points to keep
                        in mind:
                    </p>
                    <p>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Registration: </b>Foreign investors must register their company with the
                                Registrar of Joint Stock Companies and Firms (RJSC) under the Companies Act,
                                1994. They also need to obtain a Tax Identification Number (TIN) from the
                                National Board of Revenue (NBR).
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Licensing: </b>Depending on the sector and type of investment, foreign
                                investors may require additional licences or permits from relevant
                                authorities such as the Bangladesh Investment Development Authority (BIDA),
                                Bangladesh Bank, or the Board of Investment (BOI).
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Investment approval: </b>Foreign investments over a certain threshold
                                require prior approval from the government. For example, investments in the
                                manufacturing sector over USD 5 million require approval from the BIDA,
                                while investments in the service sector over USD 2 million require approval
                                from the BOI.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Repatriation of profits: </b>Foreign investors are allowed to repatriate
                                profits, dividends, and capital gains from their investments in Bangladesh.
                                They must obtain permission from the Bangladesh Bank and comply with foreign
                                exchange regulations.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Taxation: </b>Foreign investors are subject to corporate income tax,
                                which is currently 25%. However, certain industries such as software
                                development and IT-enabled services are eligible for reduced tax rates.
                            </span>
                        </div>
                        So, foreign investors must comply with investment procedures and regulations set by
                        the government of Bangladesh to invest in the country.
                    </p>
                    <p className="color-text fs-5 mb-4">
                        <b>How can foreign investors get started with investing in Bangladesh</b>
                    </p>
                    <p>
                        Foreign investors who are interested in investing in Bangladesh can take the
                        following steps to get started:
                    </p>
                    <p>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Conduct Market Research: </b>Before investing in Bangladesh, foreign
                                investors should conduct market research to determine the potential demand
                                for their products or services. This includes analyzing market trends,
                                identifying competitors, and understanding consumer behavior’s.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Identify Local Partners: </b>Identifying local partners is an important
                                step for foreign investors to get started with investing in Bangladesh.
                                Local partners can provide valuable insights into local regulations,
                                business practices, and cultural nuances. They can also help establish
                                relationships with key stakeholders and customers.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Seek Expert Advice: </b>Foreign investors can seek advice from experts
                                such as lawyers, accountants, and consultants who have experience with
                                investing in Bangladesh. These experts can provide guidance on legal and
                                regulatory requirements, tax laws, and investment opportunities.
                            </span>
                        </div>
                        Like, “JK Associates“ is a top-ranked Corporate Consultancy and Law firm in
                        Bangladesh with an international presence providing specialized services in
                        Intellectual Property Rights, Corporate Affairs, Foreign Direct Investment and
                        Trade, Taxation, and Litigation.
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Attend Trade Events and Join Industry Associations: </b>Attending trade
                                events and joining industry associations can provide foreign investors with
                                valuable networking opportunities and insights into industry trends.
                                Industry associations can also help investors stay up-to-date with local
                                regulations and market developments.
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                <b>Set Up Business and Obtain Required License’s:</b> Once foreign investors
                                have identified local partners, conducted market research, and sought expert
                                advice, they can set up their business and obtain the required license’s and
                                permits from relevant authorities such as the Bangladesh Investment
                                Development Authority (BIDA) and the Board of Investment (BOI).
                            </span>
                        </div>
                        Overall, foreign investors who want to invest in Bangladesh should take a strategic
                        and cautious approach. Conducting thorough market research, identifying local
                        partners, seeking expert advice, attending trade events and joining industry
                        associations, and obtaining required license’s and permits are key steps to get
                        started with investing in Bangladesh.
                    </p>
                </div>
            </div>

            <div className='container-xxl center-background1'>
                <h2> Related Articles</h2>
            </div>

            <div className='container-xxl center-background1'>
                <Marquee className="marquee-container">
                    <MarqueeCard
                        imageUrl={openForeignCompany}
                        title="Foreign Company Formation"
                        buttonText="Read More"
                        buttonLink="/foreign-company-formation"
                    />
                    <MarqueeCard
                        imageUrl={workPermitVISA}
                        title="Work Permit Visa In Bangladesh"
                        buttonText="Read More"
                        buttonLink="/work-permit-visa"
                    />
                    <MarqueeCard
                        imageUrl={privateInvestmentImg}
                        title="Private Investment VISA"
                        buttonText="Read More"
                        buttonLink="/private-investment-visa"
                    />
                    <MarqueeCard
                        imageUrl={directorServiceImg}
                        title="Foreign Company Director Service"
                        buttonText="Read More"
                        buttonLink="/foreign-company-director-service"
                    />
                    <MarqueeCard
                        imageUrl={foreignDelegatesImg}
                        title="Foreign Delegates"
                        buttonText="Read More"
                        buttonLink="/foreign-delegates"
                    />
                    <MarqueeCard
                        imageUrl={foreigncompanyregisteredaddressImg}
                        title="Foreign Company Registered Address"
                        buttonText="Read More"
                        buttonLink="/foreign-company-registered-address"
                    />
                    <MarqueeCard
                        imageUrl={foreigncompanydirectorserviceImg}
                        title="Foreign Direct Investment"
                        buttonText="Read More"
                        buttonLink="/foreign-company-director-service"
                    />
                    <MarqueeCard
                        imageUrl={BidaImg}
                        title="BIDA Permission"
                        buttonText="Read More"
                        buttonLink="/bida-permission"
                    />
                </Marquee>
            </div>

            <div className="container py-5 my-0">
                <h2 className="color-text text-center mb-4">Foreign DirectInvestment FAQ</h2>
                <Faq items={faqItems} />
            </div>
            <Footer />
        </>
    )
}

export default ForeignDirectInvestment